<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4 px-4">
    <div class="apply-leave-form custom-form-card mt-3 p-4" [ngClass]="{ 'dark-form-card': selectedMode === 'dark' }">
      <div class="luxury-form-container" [ngClass]="{ 'dark-mode': selectedMode === 'dark' }">
        <!-- Header Section -->
        <div class="form-header">
          <div class="header-content">
            <div class="icon-box">
              <i class="fas fa-umbrella-beach"></i>
            </div>
            <div class="title-group">
              <h1>Public Holidays</h1>
              <p>Define holiday names and scheduled dates</p>
            </div>
          </div>
          <button type="button" class="btn-close-circle" (click)="cancel.emit()">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Form Body -->
        <form class="luxury-form" #f="ngForm" (ngSubmit)="onSubmit(f)">
          <div class="form-body">
            <!-- Holiday Name Input -->
            <div class="form-section full-width">
              <div class="input-wrapper">
                <label for="name">
                  <i class="fas fa-tag"></i> Holiday Name
                </label>
                <input type="text" ngModel #name="ngModel" name="name" id="name"
                  placeholder="Enter holiday name (e.g., Annual Gala)" required />
              </div>
            </div>

            <!-- Date Range Section -->
            <div class="form-section-group">
              <div class="form-section">
                <div class="input-wrapper">
                  <label for="startDate">
                    <i class="fas fa-calendar-alt"></i> Start Date
                  </label>
                  <input type="date" ngModel #startDate="ngModel" name="startDate" id="startDate" required />
                </div>
              </div>

              <div class="form-section">
                <div class="input-wrapper">
                  <label for="endDate">
                    <i class="fas fa-calendar-check"></i> End Date <span class="optional">(Optional)</span>
                  </label>
                  <input type="date" ngModel #endDate="ngModel" name="endDate" id="endDate" />
                </div>
              </div>
            </div>

            <div class="info-tip">
              <i class="fas fa-info-circle"></i>
              <span>Creating a range will automatically generate consecutive holidays.</span>
            </div>
          </div>

          <!-- Footer Actions -->
          <div class="form-footer">
            <button type="button" class="btn-cancel" (click)="cancel.emit()">Discard</button>
            <button type="submit" class="btn-submit" [disabled]="showSpinner">
              <span *ngIf="!showSpinner">Save Holiday</span>
              <span *ngIf="showSpinner" class="loader-inline"></span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</main>